const formatter = Intl.NumberFormat('en', { notation: 'compact' });

// 1000000->1M etc
export const formatLongNumber = (number: number) => formatter.format(number);
